// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PLocationOutlinedSvg from "@fishx/icons-svg/es/asn/PLocationOutlined";
import FishxIcon from '../components/FishxIcon';

var PLocationOutlined = function PLocationOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PLocationOutlinedSvg
  }));
};

PLocationOutlined.displayName = 'PLocationOutlined';
export default React.forwardRef(PLocationOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PLocationOutlined.js
// module id = 3496
// module chunks = 0